"use client";
import { useState, useEffect } from "react";

const CustomCursor = () => {
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    let requestId: number;

    const moveCursor = (e: MouseEvent) => {
      requestId = requestAnimationFrame(() => {
        setPosition({ x: e.clientX, y: e.clientY });
      });
    };

    const hideCursor = () => setVisible(false);
    const showCursor = () => setVisible(true);

    window.addEventListener("mousemove", moveCursor);
    window.addEventListener("mouseenter", showCursor);
    window.addEventListener("mouseleave", hideCursor);

    return () => {
      window.removeEventListener("mousemove", moveCursor);
      window.removeEventListener("mouseenter", showCursor);
      window.removeEventListener("mouseleave", hideCursor);
      cancelAnimationFrame(requestId);
    };
  }, []);

  return (
    <div
      className={`fixed top-0 left-0 w-6 h-6 bg-[#fff000] rounded-full pointer-events-none transition-transform duration-100 ease-out ${
        visible ? "opacity-100 scale-100" : "opacity-0 scale-50"
      }`}
      style={{
        transform: `translate(${position.x}px, ${position.y}px)`,
        zIndex: 9999, // Ensures it stays on top
      }}
    />
  );
};

export default CustomCursor;
